export default __webpack_public_path__ + "static/media/playShield.1770f7f2.png";